import { render, staticRenderFns } from "./StatusInformationCard.vue?vue&type=template&id=2680daa2&scoped=true"
import script from "./StatusInformationCard.vue?vue&type=script&lang=ts"
export * from "./StatusInformationCard.vue?vue&type=script&lang=ts"
import style0 from "./StatusInformationCard.vue?vue&type=style&index=0&id=2680daa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2680daa2",
  null
  
)

export default component.exports